import React, { useState } from "react";
import Header from "../components/header";
import SidebarHeader from "../components/sidebarHeader";
import { useMediaQuery } from "react-responsive";
import Footer from "../components/Footer";
import { useSelector } from "react-redux"; // Import useSelector from Redux

const AboutUs = () => {
  // State
  const [menu, setMenu] = useState("");

  // Query for responsive layout
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1150px)",
  });

  // Get the language from Redux state
  const isLang = useSelector((state) => state.authReducer.lang); // Get language from the Redux store

  // Function to handle mouse hover for the menu
  const handleMouseOver = (type) => {
    setMenu(type);
  };

  return (
    <>
      {isDesktopOrLaptop ? (
        <Header menu={menu} setMenu={setMenu} />
      ) : (
        <SidebarHeader />
      )}
      <div onMouseOver={() => handleMouseOver("")}
       className={`text-black ${isLang === "eng" ? "text-left" : "text-right"}`}
      >
        <section className="custon-section w-full">
          <div className="custon-container">
            <p
              className="font-[700] text-[22px] md:text-[28px] flex items-center justify-center bg-gradient-to-r from-purple-700 to-purple-800 lg:text-[28px]  py-20"
              style={{
                fontFamily: "poppins",
                height: "250px",
                color: "#FFF",
              }}
            >
              {isLang === "eng" ? "About Us" : "معلومات عنا"}
            </p>

            <div className="bg-white shadow-lg  rounded-lg p-8 w-full mt-4">
              <div className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">
                  {isLang === "eng"
                    ? "A One-Stop Spot Where You Can Pick-Up The Most Sophisticated Design Solutions"
                    : "مكان متكامل حيث يمكنك أستخدام  حلول التصميم الأكثر تطورًا"}
                </h2>
                <p className="text-base text-gray-700">
                  {isLang === "eng"
                    ? "Maker4U is a trusted leading platform that perfectly empowers the world to design with an unwavering dedication to excellence. We are passionate about technology and zealots for simple, aesthetically pleasing user interfaces."
                    : "Maker4U  هي منصة رائدة موثوقة تعمل على تمكين العالم من التصميم بتفانٍ عال لتحقيق التميز. نحن شغفاء للتكنولوجيا وطامعون لواجهات المستخدم البسيطة والممتعة من الناحية الجمالية."}
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">
                  {isLang === "eng" ? "Break boundaries with MAKER4U!" : "اكسر الحدود مع ! MAKER4U"}
                </h2>
                <p className="text-base text-gray-700">
                  {isLang === "eng"
                    ? "Maker4U's online graphic design solutions provide flawlessly pre-designed and editable templates that can inspire your creativity no matter what you want to create."
                    : "توفر حلول التصميم الجرافيكي عبر الإنترنت من Maker4U نماذج مصممة مسبقًا وقابلة للتحرير بشكل سلس والتي بامكانها أن تلهم إبداعك بغض النظر عما تريد إنشاءه."}
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">
                  {isLang === "eng"
                    ? "Skilled Templates and Elements for All of Your Projects"
                    : "نماذج وعناصر ماهرة لجميع مشاريعك"}
                </h2>
                <p className="text-base text-gray-700">
                  {isLang === "eng"
                    ? "Create content, brand assets, social media posts, graphics, banners, and more in minutes with the help of hundreds of lovely templates."
                    : "قم بإنشاء المحتوى وأصول العلامة التجارية ومنشورات الوسائل الاجتماعية والرسومات واللافتات والمزيد في دقائق بمساعدة مئات النماذج الرائعة."}
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">{isLang === "eng" ? "Individualized" : "تفرد"}</h2>
                <p className="text-base text-gray-700">
                  {isLang === "eng"
                    ? "Resize your designs easily using our free services. Create personalized color schemes and upload your fonts, images, and logos."
                    : "قم بتغيير حجم تصاميمك بسهولة باستخدام خدماتنا المجانية. قم بإنشاء أنظمة ألوان مخصصة وقم بتحميل الخطوط والصور والشعارات الخاصة بك."}
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">{isLang === "eng" ? "Inspired" : "ملهم"}</h2>
                <p className="text-base text-gray-700">
                  {isLang === "eng"
                    ? "You'll get ideas for incredible designs from our carefully chosen material. Explore our hundreds of excellent movies, pictures, graphics, and collections. We have over a million premium photos."
                    : "ستحصل على أفكار لتصاميم مذهلة من المواد المختارة بعناية. استكشف المئات من الأفلام والصور والرسومات والمجموعات المميزة لدينا. لدينا أكثر من مليون صورة متميزة."}
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">{isLang === "eng" ? "Secured" : "آمن"}</h2>
                <p className="text-base text-gray-700">
                  {isLang === "eng"
                    ? "We ensure that every picture and video in our collection has a commercial use license, shielding you from any issues related to copyright."
                    : "نحن نضمن أن كل صورة وفيديو في مجموعتنا مرخصة للاستخدام التجاري، مما يحميك من أي مشاكل تتعلق بحقوق الطبع والنشر."}
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">
                  {isLang === "eng" ? "Bringing Art to Everyone" : "توفير الفن للجميع"}
                </h2>
                <p className="text-base text-gray-700">
                  {isLang === "eng"
                    ? "Being with Maker4U. The amazing results will come next! Maker4U is an easy-to-use online photo editor that's powerful and available worldwide. With special Maker4U smart technologies, you can make beautiful photos, stunning graphics, and incredible Art for everyone. It's a website where you can design things and share them anywhere. Their goal is to help everyone become a designer."
                    :"مع أستخدام Maker4U. النتائج المذهلة سوف ستأتي! Maker4U هو محرر صور سهل الاستخدام عبر الإنترنت وقوي ومتوفر في جميع أنحاء العالم. باستخدام تقنيات Maker4U الذكية، يمكنك إنشاء صور جميلة ورسومات مذهلة وفن مذهل للجميع. إنه موقع على شبكة الإنترنت حيث يمكنك تصميم الأشياء ومشاركتها في أي مكان. هدفهم هو مساعدة الجميع على أن يصبحوا مصممين." 
                  }
                  </p>
              </div>

              <div className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">
                  {isLang === "eng" ? "Who we are" : "من نحن"}
                </h2>
                <p className="text-base text-gray-700">
                  {isLang === "eng"
                    ? "We are creative, inspiring, helpful, fun—-"
                    :"نحن مبدعون، ملهمون، مفيدون ومرحون —-" 
                  }
                  </p>

                  <p className="text-base text-gray-700">
                  {isLang === "eng"
                    ? "Our expertise is to gather people with interesting stories and competencies around the world. Thus, you can take your ideas to a new level. We take many delightful things. We curate a library of trendy templates and high-quality stock photos to jumpstart your creativity as we assist you in accomplishing stunning feats!"
                    :"تتمثل خبرتنا في جمع الأشخاص ذوي القصص والكفاءات المثيرة حول العالم. لكي تتمكن من رفع أفكارك إلى مستوى جديد. نحن نأخذ العديد من الأشياء المبهجة. نحن ننظم مكتبة من النماذج العصرية والصور المخزنة عالية الجودة لتحفيز إبداعك حيث نساعدك في تحقيق إنجازات مذهلة!" 
                  }
                  </p>
                  <p className="text-base text-gray-700">
                  {isLang === "eng"
                    ? "We are convinced that design, which can transform, is a magic wand, and community, providing the necessary support, is a thread that binds us all. Ultimately, the goal is for this statement to ring true, where the team can confidently claim that they are the ones who are unconventional and out of the box."
                    :"نحن مقتنعون بأن التصميم الذي يمكن أن يتحول، هو كالعصا السحرية، والمجتمع الذي يقدم الدعم اللازم، هو الخيط الذي يربطنا جميعًا. في النهاية، الهدف هو أن يصبح هذا واقعاً، حيث يمكن للفريق أن يدعي بثقة أنهم هم الأشخاص الغير تقليديين والخارجون عن الصندوق." 
                  }
                  </p>
                 
              </div>


              <div className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">
                  {isLang === "eng" ? "WHAT WE DO" : "ما نفعله"}
                </h2>
                <p className="text-base text-gray-700">
                  {isLang === "eng"
                    ? "We Guaranteed Every Design is trendy and Easy To Be Customized!"
                    :"نحن نضمن أن كل تصميم عصري وسهل التخصيص!" 
                  }
                  </p>

                  <p className="text-base text-gray-700">
                  {isLang === "eng"
                    ? "Our goal is to assist people in transforming their ideas into fantastic designs quickly, effortlessly, and with top-notch quality. We (electrify the sector) level up the design game by empowering everyone to create professional-looking visuals by offering superior quality to all users across the board, including designers, marketers, small-scale business-minded people, educators, and online content creators."
                    :"هدفنا هو مساعدة الناس على تحويل أفكارهم إلى تصميمات رائعة بسرعة وسهولة وبجودة عالية. نحن (نحفز القطاع) نعمل على رفع مستوى مجال التصميم من خلال تمكين الجميع من إنشاء صور بمظهر احترافي من خلال تقديم جودة فائقة لجميع المستخدمين في جميع المجالات، بما في ذلك المصممين، المسوقين، ذوي الأعمال الناشئة، المعلمين ومنشئي المحتوى عبر الإنترنت. " 
                  }
                  </p>
              </div>

              <div className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">
                  {isLang === "eng" ? "We're Direct" : "نحن صريحين"}
                  {isLang === "eng" ? "We Speak Clearly" : "نحن نتحدث بوضوح"}
                </h2>
                <p className="text-base text-gray-700">
                  {isLang === "eng"
                    ? "We strongly avow dialog that is sincere and forthright as it is the sole guarantee for mutual respect and understanding in the workplace."
                    :"نحن نؤيد الحوار الصادق والصريح لأنه الضمان الوحيد للاحترام المتبادل والتفاهم في مكان العمل." 
                  }
                  </p>

              </div>

              <div className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">
                  {isLang === "eng" ? "Adventure and Growth" : "المغامرة والتطور"}
                </h2>
                <p className="text-base text-gray-700">
                  {isLang === "eng"
                    ? "Each new challenge is for us like a short journey, we finish it by learning not to be scared of danger, and who knows, may these adventures prepare us for whatever comes ahead."
                    :"كل تحدٍ جديد لنا هو بمثابة رحلة قصيرة، نكملها بتعلم عدم الخوف من المخاطر، ومن يدري، قد تساعدنا هذه المغامرات لما سيأتي في المستقبل." 
                  }
                  </p>
              </div>

              <div className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">
                  {isLang === "eng" ? "Strong Teamwork" : "العمل الجماعي القوي"}
                </h2>
                <p className="text-base text-gray-700">
                  {isLang === "eng"
                    ? "Being a well-organized unit of the staff is our mighty success. We are a group that is brought together by the desire to make every effort possible to have the common aims fulfilled."
                    :"إن كوننا وحدة جيدة التنظيم من الموظفين هو سر نجاحنا. نحن مجموعة تجمعنا الرغبة في بذل كل جهد ممكن لتحقيق الأهداف المشتركة." 
                  }
                  </p>
              </div>

              <div className="mb-8">
  <h2 className="text-2xl font-semibold mb-4">
    {isLang === "eng" ? "Simplicity is Key" : "البساطة هي المفتاح"}
  </h2>
  <p className="text-base text-gray-700">
    {isLang === "eng"
      ? "Simple, transparent, and easy-to-use processes are the goals we set. We strive to develop easy-to-use and comprehensive tools and materials with which designers can quickly and easily create brilliant and unique designs."
      : "جعل العمليات بسيطة وشفافة وسهلة الاستخدام هي الأهداف التي حددناها. نحن نسعى جاهدين لتطوير أدوات ومواد سهلة الاستخدام وشاملة يمكن للمصممين من خلالها إنشاء تصاميم رائعة وفريدة من نوعها بسرعة وسهولة."
    }
  </p>
</div>

<div className="mb-8">
  <h2 className="text-2xl font-semibold mb-4">
    {isLang === "eng" ? "Transparent Communication" : "التواصل الشفاف"}
  </h2>
  <p className="text-base text-gray-700">
    {isLang === "eng"
      ? "We care about mutual communication being held in an atmosphere where everybody feels like having a voice."
      : "نحن نهتم بإجراء التواصل المتبادل في جو يشعر فيه الجميع برغبة في أن يكون لهم رأي."
    }
  </p>
</div>

<div className="mb-8">
  <h2 className="text-2xl font-semibold mb-4">
    {isLang === "eng" ? "Simplify Complexities" : "تبسيط التعقيدات"}
  </h2>
  <p className="text-base text-gray-700">
    {isLang === "eng"
      ? "The main focus of our developer efforts is on providing clean simple, easy-to-use solutions that help to solve real problems."
      : "ينصب التركيز الرئيسي لجهود المطورين لدينا على توفير حلول بسيطة وسهلة الاستخدام تساعد في حل المشاكل الحقيقية."
    }
  </p>
</div>

<div className="mb-8">
  <h2 className="text-2xl font-semibold mb-4">
    {isLang === "eng" ? "Pursue Excellence" : "السعي نحو التميز"}
  </h2>
  <p className="text-base text-gray-700">
    {isLang === "eng"
      ? "The way of spearheading our leadership is by maintaining high standards and constantly showing coworkers how to be better professionals."
      : "تتمثل طريقة القيادة لدينا  في الحفاظ على معايير عالية وارشاد زملاء العمل كيف يصبحون محترفين أفضل."
    }
  </p>
</div>

<div className="mb-8">
  <h2 className="text-2xl font-semibold mb-4">
    {isLang === "eng" ? "Set Ambitious Goals" : "تحديد اهداف طموحة"}
  </h2>
  <p className="text-base text-gray-700">
    {isLang === "eng"
      ? "We strive to make our dreams come true, we strike the balance of the day, and we work hard to accomplish them. Finally, we enjoy every bit of accomplishment."
      : "نحن نسعى جاهدين لتحقيق أحلامنا ونعمل جاهدين لتحقيقها. وأخيرا، نحن نستمتع بكل لحظة من الإنجاز."
    }
  </p>
</div>

            </div>
          </div>
        </section>

        <footer>
          <Footer />
        </footer>
      </div>
    </>
  );
};

export default AboutUs;
